import { useQuery } from '@tanstack/react-query';
import { useApiEssentials } from '../../../shared/hooks/useApiEssentials';
import {
  DOCUMENTATION_API_BASE_PATH,
  documentationQueryDefaults,
  documentationQueryKeys,
  fetchDocumentationTabs,
} from '../api/documentationApi';
import { DocumentationTab } from '../api/types';

export function useDocumentationTabs() {
  const { apiUrl, getIdToken, isSignedIn } = useApiEssentials(
    DOCUMENTATION_API_BASE_PATH,
  );

  return useQuery<DocumentationTab[], Error>({
    queryKey: documentationQueryKeys.tabs,
    queryFn: async () => {
      const idToken = await getIdToken();
      return fetchDocumentationTabs(apiUrl, idToken);
    },
    enabled: !!apiUrl && isSignedIn,
    ...documentationQueryDefaults,
  });
}
